import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GradeModel } from 'data/grade/grade.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: GradeModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<GradeModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const gradeSlice = createSlice({
  name: 'grade',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default gradeSlice;
